import React from 'react'
import { FormControl, FormLabel, Select, Text } from '@chakra-ui/react'
import countries from '../utils/countries'

type CountrySelectProps = {
  defaultValue?: string
  onChange: (country: string) => void
  required?: boolean
  hideLabel?: boolean
  id?: string
  'aria-label'?: string
}

const CountrySelect: React.FC<CountrySelectProps> = ({
  defaultValue,
  onChange,
  required,
  hideLabel = false,
  id,
  'aria-label': ariaLabel,
}) => {
  return (
    <FormControl id={id}>
      {!hideLabel && (
        <FormLabel>
          Country{' '}
          {required && (
            <Text as='span' color='red.500'>
              *
            </Text>
          )}
        </FormLabel>
      )}
      <Select
        placeholder='Choose Country'
        defaultValue={defaultValue}
        onChange={(e) => onChange(e.target.value)}
        aria-label={ariaLabel}
      >
        {countries.map((country) => (
          <option value={country} key={country}>
            {country}
          </option>
        ))}
      </Select>
    </FormControl>
  )
}

export default CountrySelect
